import React from 'react';
import { Card, CardBody, CardFooter, Typography, Button } from "@material-tailwind/react";
import PropTypes from 'prop-types';
import {useNavigate } from "react-router-dom";

const SuggestedContractCard = ({ contract, description, isSuggested }) => {
  const navigate = useNavigate();
  return (
    <Card
      className={`mx-8 w-full  sm:w-96 md:w-120 border rounded-2xl overflow-hidden ${isSuggested ? 'border-4 border-purple-400 shadow-lg transform hover:scale-105 transition-transform duration-300 bg-gradient-to-r from-purple-300 to-purple-400 hover:border-indigo-300' : 'border-gray-400 hover:border-indigo-500'}`}
    >
      <CardBody className="flex flex-col items-center p-8">
        <Typography variant="h5" color={isSuggested ? 'yellow-800' : 'blue-gray'} className={`mb-4 text-center text-lg font-bold ${isSuggested ? 'text-2xl' : 'text-xl'}`}>
          {`Contract ${contract}`}
        </Typography>
        <Typography className={`text-center text-base ${isSuggested ? 'text-gray-800' : 'text-gray-600'}`}>
          {description}
        </Typography>
      </CardBody>
      <CardFooter className="pt-0 flex items-center justify-center">
        <Button
        onClick={() => {

          navigate("/LegalEducation");
        }}
          size="sm"
          className={`flex items-center bg-white gap-2 ${isSuggested ? 'text-white bg-indigo-600 hover:bg-indigo-700' : 'text-indigo-800 hover:bg-indigo-100'} rounded-full px-6 py-2 mb-4 transition-all duration-300 ease-in-out transform hover:scale-105`}
        >
          Learn More
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
          </svg>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default SuggestedContractCard;

SuggestedContractCard.propTypes = {
  contract: PropTypes.string,
  description: PropTypes.string,
  isSuggested: PropTypes.bool,
};
